// tslint:disable:max-line-length
import * as React from 'react';
import { createIcon } from '../createIcon';

function Checkbox() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "10",
    viewBox: "0 0 12 10"
  }, /*#__PURE__*/React.createElement("path", {
    "data-fill-rule": "fill",
    fillRule: "evenodd",
    d: "M3.983 9.193l.97.807.824-.963L12 1.773 10.048 0 4.562 6.403 1.636 3.794 0 5.878z"
  }));
}

export var CheckboxIcon = createIcon(Checkbox); // tslint:enable:max-line-length